/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PipelineSegment } from './PipelineSegment';
import {
    PipelineSegmentFromJSON,
    PipelineSegmentFromJSONTyped,
    PipelineSegmentToJSON,
    PipelineSegmentToJSONTyped,
} from './PipelineSegment';

/**
 * 
 * @export
 * @interface PaginatedPipelineSegmentList
 */
export interface PaginatedPipelineSegmentList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedPipelineSegmentList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedPipelineSegmentList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedPipelineSegmentList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<PipelineSegment>}
     * @memberof PaginatedPipelineSegmentList
     */
    results: Array<PipelineSegment>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedPipelineSegmentList
     */
    numPages?: number;
}

/**
 * Check if a given object implements the PaginatedPipelineSegmentList interface.
 */
export function instanceOfPaginatedPipelineSegmentList(value: object): value is PaginatedPipelineSegmentList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedPipelineSegmentListFromJSON(json: any): PaginatedPipelineSegmentList {
    return PaginatedPipelineSegmentListFromJSONTyped(json, false);
}

export function PaginatedPipelineSegmentListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedPipelineSegmentList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] === undefined ? undefined : json['next'] === null ? null : json['next'],
        'previous': json['previous'] === undefined ? undefined : json['previous'] === null ? null : json['previous'],
        'results': ((json['results'] as Array<any>).map(PipelineSegmentFromJSON)),
        'numPages': json['num_pages'] == null ? undefined : json['num_pages'],
    };
}

export function PaginatedPipelineSegmentListToJSON(json: any): PaginatedPipelineSegmentList {
    return PaginatedPipelineSegmentListToJSONTyped(json, false);
}

export function PaginatedPipelineSegmentListToJSONTyped(value?: PaginatedPipelineSegmentList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(PipelineSegmentToJSON)),
        'num_pages': value['numPages'],
    };
}

